import { render, staticRenderFns } from "./BranchManage.vue?vue&type=template&id=f908a93e&scoped=true&"
import script from "./BranchManage.vue?vue&type=script&lang=js&"
export * from "./BranchManage.vue?vue&type=script&lang=js&"
import style0 from "./BranchManage.vue?vue&type=style&index=0&id=f908a93e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f908a93e",
  null
  
)

export default component.exports